module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('main', {
    attrs: {
      "role": "primary"
    }
  }, [_c('div', {
    staticClass: "row expanded collapse align-center"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "section--intro",
    style: ({
      height: (_vm.sectionHeight + "px")
    })
  }, [_c('div', {
    staticClass: "mxr-intro"
  }, [_c('div', {
    staticClass: "loader-logo__wrap"
  }, [_c('svg', {
    staticClass: "loader-logo",
    staticStyle: {
      "enable-background": "new 0 0 152.944 62.917"
    },
    attrs: {
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 152.944 62.917",
      "xml:space": "preserve"
    }
  }, [_c('defs', [_c('clipPath', {
    attrs: {
      "id": "logoSymb"
    }
  }, [_c('path', {
    attrs: {
      "fill": "#000000",
      "d": "M121.455,0.002H31.489c-6.72-0.073-14.067,2.44-19.612,6.875C4.341,12.905,0,21.852,0,31.458\n              c0,17.349,14.127,31.459,31.489,31.459h62.186l-0.029-0.043c6.502-4.964,22.696-18.842,30.573-28.364\n              c2.08-2.505,1.328-3.797-0.57-5.276c-9.599-7.496-11.594-8.144-26.906-5.911c-7.876,1.157-41.462,9.079-46.591,9.823\n              c-3.562,0.501-5.481,0.297-7.841-0.831c-6.898-3.726-15.567-8.603-16.997-9.426c0.524,1.831,2.061,3.616,3.247,4.553\n              c1.177,0.942,4.949,3.725,9.572,6.866c4.634,3.136,7.239,4.428,18.027,2.908c4.976-0.695,38.804-6.042,44.564-5.857\n              c2.419,0.084,2.436-0.014,4.989,2.177c0.683,0.58,0.922,1.387-0.035,2.237c-2.801,2.474-14.721,11.765-20.449,15.574h-53.74\n              c-10.978,0-19.911-8.921-19.911-19.891c0-13.698,11.914-19.883,19.96-19.883h89.917c10.97,0,19.906,8.916,19.906,19.883\n              c0,10.97-8.936,19.891-19.906,19.891h-1.785l-13.102,11.568h14.887c17.362,0,31.489-14.11,31.489-31.459\n              C152.944,14.12,138.817,0.002,121.455,0.002"
    }
  })])]), _vm._v(" "), _c('path', {
    attrs: {
      "id": "animPath",
      "clip-path": "url(#logoSymb)",
      "fill": "none",
      "stroke": "#ffffff",
      "stroke-width": "19",
      "stroke-miterlimit": "0",
      "d": "M24.312,22.89l17.657,11.892 c0,0,14.186,0.439,32.333-3.324c14.311-2.968,6.5-1.676,15.854-3.238c24.691-4.123,30.479,3.238,26.251,6.691\n              c-6.497,5.306-25.772,21.705-25.772,21.705H28.969c0,0-23.167-1.333-23.167-26.5s28.667-25.5,28.667-25.5h88.333\n              c0,0,24.333,3,24.333,25.167c0,18-7.329,26.809-22.162,26.72l-5.501,0.044c0,0-9.337-2.765-14.837,5.569"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "logotype__wrap"
  }, [_c('svg', {
    staticClass: "logotype",
    staticStyle: {
      "enable-background": "new 0 0 381.131 87.773"
    },
    attrs: {
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 381.131 87.773",
      "xml:space": "preserve"
    }
  }, [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#FFFFFF"
    },
    attrs: {
      "d": "M56.304,23.394H37.62L63.379,0H48.686L22.409,23.394H12.131V0H0v62.986h12.131V32.208H51.98v30.778\n                h12.111V30.375C64.091,26.542,60.493,23.394,56.304,23.394"
    }
  })]), _vm._v(" "), _c('g', [_c('path', {
    staticStyle: {
      "fill": "#FFFFFF"
    },
    attrs: {
      "d": "M135.717,23.394H79.417v8.813h52.001v7.287h-45.13c-3.726,0-6.838,3.586-6.838,7.751v8.564\n                  c0.29,3.885,3.316,7.176,6.838,7.176h57.212V30.375C143.499,26.542,139.922,23.394,135.717,23.394z M131.417,54.064H91.393V46.8\n                  h40.024V54.064z"
    }
  })]), _vm._v(" "), _c('g', [_c('rect', {
    staticStyle: {
      "fill": "#FFFFFF"
    },
    attrs: {
      "x": "157.651",
      "width": "12.161",
      "height": "63.002"
    }
  })]), _vm._v(" "), _c('g', [_c('path', {
    staticStyle: {
      "fill": "#FFFFFF"
    },
    attrs: {
      "d": "M248.012,46.825V30.519c-0.331-3.907-3.366-7.124-6.863-7.124h-30.735l-0.008,0.024h-18.773\n                    c-3.87,0-7.225,2.72-7.669,6.187v26.33c0,3.859,3.555,6.989,7.737,7.01h56.311v-8.82h-52.026v-7.302H248.012z M195.986,32.28h40.057\n                    v7.264h-40.057V32.28z"
    }
  })]), _vm._v(" "), _c('g', [_c('path', {
    staticStyle: {
      "fill": "#FFFFFF"
    },
    attrs: {
      "d": "M327.433,62.901V30.266c0-3.723-3.569-6.871-7.764-6.871h-56.532v39.506h12.119V32.127h40.121v30.774\n                      H327.433z"
    }
  })]), _vm._v(" "), _c('g', [_c('path', {
    staticStyle: {
      "fill": "#FFFFFF"
    },
    attrs: {
      "d": "M342.22,67.384c0,1.918-1.333,3.154-1.333,3.154l-18.608,17.235h14.911l14.51-14.276\n                        c0,0,2.57-2.237,2.57-6.094V23.394H342.22V67.384z"
    }
  }), _c('rect', {
    staticStyle: {
      "fill": "#FFFFFF"
    },
    attrs: {
      "x": "342.22",
      "y": "4.793",
      "width": "12.051",
      "height": "9.684"
    }
  })]), _vm._v(" "), _c('g', [_c('rect', {
    staticStyle: {
      "fill": "#FFFFFF"
    },
    attrs: {
      "x": "369.098",
      "y": "23.394",
      "width": "12.033",
      "height": "39.493"
    }
  }), _c('rect', {
    staticStyle: {
      "fill": "#FFFFFF"
    },
    attrs: {
      "x": "369.098",
      "y": "4.793",
      "width": "12.033",
      "height": "9.684"
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "mxr-intro__dkt"
  }, [_c('div', {
    staticClass: "logo-by-decathlon__wrap"
  }, [_c('svg', {
    staticClass: "logo-by-decathlon",
    staticStyle: {
      "enable-background": "new 0 0 244.265 47.783"
    },
    attrs: {
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 244.265 47.783",
      "xml:space": "preserve"
    }
  }, [_c('rect', {
    staticStyle: {
      "fill": "#FFFFFF"
    },
    attrs: {
      "x": "58.018",
      "y": "4.442",
      "width": "183.152",
      "height": "40.228"
    }
  }), _vm._v(" "), _c('g', [_c('path', {
    staticStyle: {
      "fill": "#FFFFFF"
    },
    attrs: {
      "d": "M23.896,15.561c1.05,0.516,1.66,1.184,1.815,2.059c0.149,0.852,0.009,1.759-0.449,2.742\n                c-0.455,0.971-1.144,1.975-2.025,2.999c-0.904,1.004-1.87,1.928-2.917,2.739c-0.125,0.114-0.309,0.251-0.531,0.4\n                c-0.219,0.152-0.449,0.318-0.659,0.464c-0.236,0.163-0.455,0.306-0.656,0.429c-0.207,0.122-0.353,0.234-0.455,0.312\n                c-1.523,0.937-3.072,1.736-4.63,2.407c-1.561,0.648-3.235,1.272-5.026,1.841c-0.791,0.134-1.497,0.166-2.098,0.085\n                c-0.598-0.085-1.106-0.236-1.505-0.42c-0.399-0.207-0.694-0.435-0.878-0.68c-0.198-0.263-0.274-0.485-0.245-0.68\n                c0.77,0.14,1.351,0.219,1.747,0.228c0.403,0.015,0.706,0,0.94-0.047c0.225-0.041,0.376-0.091,0.467-0.169\n                c0.099-0.061,0.225-0.125,0.376-0.192c0.041-0.642,0.047-1.219,0.047-1.73c0-0.505,0.009-0.977,0.029-1.397\n                c0.02-0.417,0.038-0.829,0.056-1.231c0.023-0.397,0.041-0.802,0.067-1.216c-0.026-1.184-0.067-2.246-0.122-3.192\n                c-0.047-0.925-0.076-1.698-0.076-2.322c-0.843,0.315-1.482,0.566-1.876,0.738c-0.403,0.196-0.7,0.318-0.884,0.408\n                c-0.196,0.088-0.312,0.131-0.356,0.131c-0.055,0-0.134-0.032-0.268-0.094c-0.119-0.052-0.21-0.157-0.228-0.312\n                c-0.041-0.157-0.061-0.318-0.061-0.493c0-0.19,0.021-0.423,0.061-0.671c0.207-0.149,0.426-0.257,0.616-0.368\n                c0.19-0.099,0.397-0.201,0.639-0.315c0.236-0.12,0.531-0.245,0.881-0.394c0.35-0.16,0.793-0.373,1.345-0.671\n                c-0.032-0.983-0.056-1.855-0.067-2.617c-0.023-0.77-0.053-1.5-0.111-2.229c-0.044-0.724-0.105-1.473-0.181-2.267\n                C6.602,9.047,6.503,8.145,6.406,7.13c0-0.119-0.213-0.093-0.674,0.064C5.301,7.363,4.784,7.574,4.209,7.868\n                C3.635,8.172,3.066,8.521,2.512,8.912c-0.551,0.4-0.966,0.791-1.219,1.184c-0.263,0.257-0.426,0.496-0.551,0.721\n                c-0.102,0.222-0.207,0.414-0.28,0.563c-0.082,0.166-0.149,0.248-0.193,0.265C0.225,11.655,0.137,11.57,0,11.357\n                c0.073-0.727,0.303-1.403,0.732-2.045c0.403-0.636,0.922-1.19,1.517-1.698c0.604-0.493,1.275-0.916,1.996-1.272\n                C4.951,5.986,5.642,5.7,6.322,5.484c0.029-0.315,0.029-0.554,0-0.723C6.284,4.589,6.296,4.443,6.354,4.294\n                c0.169-0.029,0.4-0.178,0.727-0.458c0.318-0.254,0.534-0.394,0.665-0.394c0.07,0.178,0.114,0.324,0.143,0.493\n                C7.926,4.087,7.95,4.221,7.979,4.344C8.011,4.481,8.06,4.601,8.087,4.726c0.831-0.432,1.765-0.709,2.815-0.831\n                c1.05-0.137,2.071-0.143,3.028-0.058c0.98,0.111,1.838,0.309,2.588,0.607c0.747,0.295,1.246,0.648,1.499,1.041\n                c0.633,0.761,0.861,1.616,0.671,2.559c-0.195,0.951-0.575,1.864-1.173,2.774c-0.589,0.902-1.287,1.733-2.101,2.483\n                c-0.808,0.773-1.497,1.365-2.077,1.794c0.986-0.172,1.99-0.303,3.008-0.391c1.021-0.07,2.002-0.096,2.944-0.056\n                c0.942,0.05,1.806,0.131,2.599,0.274C22.682,15.074,23.362,15.278,23.896,15.561 M8.224,6.538C8.098,8.314,8.11,9.974,8.276,11.497\n                c0.154,1.526,0.271,3.101,0.335,4.738c0.817-0.309,1.663-0.721,2.532-1.228c0.852-0.519,1.663-1.114,2.433-1.817\n                c0.764-0.715,1.432-1.511,2.007-2.372c0.569-0.872,0.98-1.852,1.243-2.932c0.099-0.522-0.111-0.998-0.598-1.363\n                c-0.487-0.385-1.153-0.648-1.99-0.758c-0.82-0.143-1.765-0.155-2.839-0.032C10.339,5.844,9.28,6.112,8.224,6.538 M9.035,29.652\n                c1.698-0.411,3.442-1.091,5.263-2.025c1.823-0.925,3.457-1.955,4.945-3.066c1.473-1.112,2.658-2.267,3.556-3.434\n                c0.89-1.161,1.263-2.22,1.097-3.154c-0.131-0.621-0.782-1.053-1.981-1.295c-1.199-0.239-2.608-0.327-4.23-0.248\n                c-1.625,0.064-3.273,0.268-4.939,0.607c-1.669,0.341-3.058,0.77-4.134,1.275v2.051c0,0.971,0.006,2.042,0.038,3.194\n                c0.026,1.167,0.088,2.302,0.154,3.44C8.872,28.114,8.936,29.016,9.035,29.652"
    }
  }), _vm._v(" "), _c('path', {
    staticStyle: {
      "fill": "#FFFFFF"
    },
    attrs: {
      "d": "M30.83,27.881c0.729,0.315,1.567-0.175,2.515-1.459c0.931-1.292,1.689-3.358,2.258-6.249\n                c0-0.023,0.111-0.023,0.304,0c0.21,0.029,0.426,0.067,0.654,0.131c0.227,0.058,0.432,0.131,0.624,0.213\n                c0.187,0.073,0.286,0.143,0.286,0.21c0,0.417-0.041,0.931-0.099,1.529c-0.061,0.586-0.137,1.231-0.207,1.952\n                c-0.088,0.706-0.137,1.453-0.172,2.246c-0.035,0.779-0.035,1.572,0,2.369c0.858-0.662,1.78-1.149,2.739-1.494\n                c0.98-0.332,1.902-0.56,2.801-0.639c0.318,0.149,0.487,0.239,0.505,0.283c0.012,0.035-0.061,0.122-0.213,0.231\n                c-1.225,0.309-2.264,0.744-3.183,1.266c-0.902,0.545-1.768,1.135-2.611,1.794c0,0.89,0.017,1.876,0.058,2.911\n                c0.032,1.041,0.053,2.094,0.053,3.136c0,1.047-0.015,2.074-0.029,3.095c-0.017,1.009-0.082,1.923-0.201,2.748\n                c-0.096,0.814-0.263,1.526-0.464,2.095c-0.219,0.58-0.493,0.971-0.843,1.17c-0.254,0.143-0.548,0.228-0.884,0.271\n                c-0.332,0.044-0.677,0.044-1,0.018c-0.335-0.026-0.654-0.094-0.957-0.193c-0.301-0.085-0.546-0.227-0.741-0.397\n                c-0.604-0.542-1.041-1.219-1.286-2.057c-0.254-0.828-0.379-1.742-0.379-2.725c0-0.992,0.125-2.01,0.379-3.051\n                c0.245-1.047,0.592-2.045,1.024-3.011c0.435-0.954,0.948-1.829,1.587-2.605c0.61-0.779,1.286-1.368,2.013-1.786\n                c0.105-1.537,0.146-3.028,0.146-4.493c-0.324,0.729-0.785,1.526-1.377,2.36c-0.607,0.855-1.351,1.514-2.249,1.987\n                c-0.986,0.397-1.826,0.367-2.509-0.12c-0.688-0.478-1.103-1.21-1.269-2.197c-0.154-1.164-0.286-2.121-0.373-2.879\n                c-0.102-0.761-0.184-1.479-0.248-2.17c-0.064-0.674-0.117-1.38-0.16-2.115c-0.056-0.732-0.122-1.648-0.225-2.745\n                c0.169-0.091,0.4-0.108,0.721-0.079c0.315,0.05,0.56,0.143,0.712,0.283c0.102,0,0.166,0.23,0.19,0.677\n                c0.047,0.464,0.076,1.033,0.108,1.742c0.02,0.706,0.079,1.482,0.134,2.302c0.07,0.837,0.178,1.622,0.318,2.372\n                c0.134,0.753,0.341,1.406,0.575,1.96C30.095,27.347,30.404,27.714,30.83,27.881 M35.702,31.437\n                c-0.198,0.196-0.385,0.397-0.604,0.575c-0.201,0.187-0.408,0.391-0.586,0.613c-0.411,0.455-0.817,1.062-1.199,1.826\n                c-0.388,0.758-0.712,1.602-0.98,2.5c-0.277,0.905-0.455,1.815-0.545,2.725c-0.108,0.916-0.085,1.733,0.064,2.459\n                c0.143,0.721,0.438,1.284,0.89,1.692c0.435,0.411,1.065,0.566,1.858,0.49c0.321-0.061,0.572-0.382,0.758-0.974\n                c0.19-0.601,0.335-1.322,0.405-2.188c0.082-0.861,0.123-1.8,0.143-2.827c0.02-1.041,0.012-2.022-0.02-2.982\n                c-0.035-0.931-0.067-1.759-0.123-2.459C35.723,32.172,35.702,31.691,35.702,31.437"
    }
  })]), _vm._v(" "), _c('polygon', {
    staticStyle: {
      "fill": "#0082C3"
    },
    attrs: {
      "points": "130.293,27.589 130.293,21.825 127.078,27.589 "
    }
  }), _vm._v(" "), _c('path', {
    staticStyle: {
      "fill": "#0082C3"
    },
    attrs: {
      "d": "M53.139,0v47.783h191.125V0H53.139z M101.578,36.586H87.663V26.478\n              c-0.4,2.815-1.593,5.225-3.527,7.118c-2.745,2.626-5.143,3.139-8.731,3.139h-9.595V11.302h8.726c4.049,0,6.899,0.528,9.574,3.022\n              c1.926,1.826,3.154,4.3,3.553,7.343V11.182h13.916v5.622h-7.751v4.137h6.721v5.444h-6.721v4.735h7.751V36.586z M136.303,36.586\n              h-6.01v-3.694h-5.849c-0.788,0.82-1.517,1.468-2.197,1.931c-2.188,1.467-4.493,2.217-7.614,2.351c-2.194,0-6.299-0.872-9.691-4.42\n              c-1.966-2.205-3.303-5.257-3.364-9.02c0.093-3.215,0.831-5.4,2.64-7.815c2.958-3.816,6.748-5.409,10.54-5.321\n              c3.939,0.157,6.739,1.505,8.667,3.238c0.738,0.575,1,0.852,1.607,1.485l-3.364,5.902c-0.519-0.756-0.942-1.199-1.639-1.771\n              c0.029,0-2.276-2.442-5.397-2.506c-3.717,0.064-6.491,3.051-6.59,6.788c-0.079,3.763,3.049,7.258,6.716,7.089\n              c3.711-0.248,5.546-3.046,5.724-3.387l9.236-16.255h6.584V36.586z M153.326,17.198h-4.849v19.537h-6.246V17.198h-4.744v-5.896\n              h15.838V17.198z M173.394,36.735h-6.29v-9.723h-6.43v9.723h-6.231V11.302h6.231v9.645h6.43v-9.645h6.29V36.735z M231.562,36.735\n              h-5.467l-9.542-14.175v14.175h-6.272v-8.673c-0.598,1.931-1.639,3.687-3.063,5.155c-2.485,2.588-5.858,3.988-9.42,3.988\n              c-3.343,0-6.272-1.071-8.635-3.145v2.675h-13.502V11.302h6.199v19.817h4.79c-1.319-2.124-2.013-4.577-2.013-7.384\n              c0-3.489,1.348-6.701,3.889-9.184c2.517-2.459,5.668-3.723,9.321-3.723c3.413,0,6.643,1.327,9.125,3.757\n              c1.575,1.549,2.698,3.34,3.308,5.289v-8.574h5.663l9.379,14.123V11.302h6.24V36.735z"
    }
  }), _vm._v(" "), _c('path', {
    staticStyle: {
      "fill": "#0082C3"
    },
    attrs: {
      "d": "M74.564,31.137h-2.509V16.78h2.48c4.621,0,7.086,2.567,7.086,7.142\n              C81.621,28.943,79.363,31.137,74.564,31.137z"
    }
  }), _vm._v(" "), _c('path', {
    staticStyle: {
      "fill": "#0082C3"
    },
    attrs: {
      "d": "M197.797,30.912c-3.533,0-6.716-3.081-6.716-7.078c0-3.725,2.976-6.716,6.789-6.716\n              c3.597,0,6.581,2.99,6.581,6.716C204.452,27.965,201.467,30.912,197.797,30.912z"
    }
  })])])])])])])]), _vm._v(" "), _c('borders', {
    attrs: {
      "show-corners": false,
      "show-text": false,
      "show-dots": false
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2cda6894"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Intro.vue
// module id = 454
// module chunks = 1